import { manageMyAccountData } from "constants-lib/seo/manageMyAccountData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

export const manageMyAccount = (schemaData) => {
  const data = schemaData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add Manage My Account JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addManageMyAccount = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-manage-my-account`,
    ) &&
    document.getElementById(`manageMyAccount`) === null
  ) {
    const script = manageMyAccountJSONLD()
    addJSONLDToHead(script, `manageMyAccount`)
  } else {
    removeElement(`manageMyAccount`)
  }
}

// JSON LD template for Manage My Account
const manageMyAccountJSONLD = () => {
  const manageMyAccountTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: manageMyAccount(manageMyAccountData),
  }
  return manageMyAccountTemplate
}
